<script>
  import Layout from '@layout/main'
  import EventSession from '@components/List/EventSession'

  import _findIndex from "lodash/findIndex";
  import _uniq from "lodash/uniq";
  import { conditionList } from "@utils/is-condition";


  export default {
    page() {
      return {
        title: `${this.cartItem.title} | 報名`,
      }
    }, 
    components: {
      Layout,
      EventSession,
      FormApplyStep0: () => import("@components/Form2/FormApplyStep0"),
      FormApplyStep1: () => import("@components/Form2/FormApplyStep1"),
      FormApplyStep2: () => import("@components/Form2/FormApplyStep2"),
    },
    props: {
      cartItem: {
        type: Object,
        default: () => {
          return {}
        }
      },
    },
    data() {
      return {
        step: 0,
        submitData: {
          sessionUuids: [],
          sessionDates: [],
          sessionRepeatUuids: [],

          meals: {},
          mealIds: [],

          couponCode: '',
          couponInfo: {},
          company:{
            name: "",
            vat: ""
          },
          isSameMemberInfo: false,
          fullName: '',
          gender: '',
          phoneCode: '+886',
          phoneNumber: '',
          email: '',
          note: '',

          isAgreePrivacy: false,
          isAgreeProtection: false
        },
      }
    },
    computed: {
      stepList() {
        return conditionList([
          {
            title: '選取場次',
            value: 0,
            condition: () => {
              return this.cartItem.registrationType === 'partial'
            }
          },
          {
            title: '選取餐食',
            value: 1,
            condition: () => {
              return this.isNeedMeal
            }
          },
          {
            title: '填寫資訊',
            value: 2,
          },
          {
            title: '報名完成',
            value: 3,
          }
        ]);

      },
      activeStep() {
        const index = _findIndex(this.stepList, (item) => {
          return item.value === this.step;
        });

        return index !== -1
          ? index
          : this.step
      },
      isNeedMeal() {
        return !!this.cartItem.meals[0] && this.cartItem.meals.some(item => {
          return item.meal.enable
        });
      },
      // defaultValueImgClass() {
      //   if(!this.defaultValue.bannerImage) {
      //     return 'isStyleWhite isDefaultBgEventItem isNotParallax'
      //   } else {
      //     return 'isNotParallax isStyleWhite'
      //   }
      // }
    },
    watch: {
      'submitData.sessionUuids'(value) {
        this.submitData.sessionDates = this.cartItem.sessions
          .filter(item => {
            return item.sessions.some(sessionItem => {
              return value.includes(sessionItem.uuid)
            })
          })
          .map(item => {
            return item.date
          })

        this.submitData.mealIds = this.cartItem.meals
          .filter(item => {
            return this.submitData.sessionDates.includes(item.date)
          })
          .map(item => {
            return item.meal.id
          })
      },
    },
    created() {
      const initSubmitData = () => {
        this.submitData.sessionUuids = this.cartItem.sessions
          .map((item) => {
            return item.sessions.filter((item2) => {
              // return !item2.hasApplied && item2.canApply && item2.checked
              return item2.checked
            })
          })
          .reduce((prev, curr) => {
            return [
              ...prev,
              ...curr
            ]
          })
          .map((item) => {
            return item.uuid
          });
      };

      const initMeals = () => {
        this.cartItem.meals.forEach(mealItem => {
          this.submitData.meals[mealItem.meal.id] = mealItem.meal.value || ''
        });
      };

      const initStep = () => {
        this.step = this.stepList[0].value;

        /* this.step = this.cartItem.registrationType === 'impartial'
          ? this.isNeedMeal
            ? 1
            : 2
          : 0 */
      };

      initSubmitData();
      initMeals();
      initStep();
    },
    methods: {
      scrollToSectionStep() {
        this.$scrollToElement({
          $el: this.$refs['sectionStep'],
          offset: 160,
        });
      },
      onSubmitStep() {
        const isLastStep = this.activeStep === this.stepList.length - 2;
        const isNeedAddCart = (this.step === 0 && this.cartItem.registrationType === 'partial')
          || this.step === 1;

        if(isLastStep) {
          this.tryToCheckoutCart();
        } else {
          const nextStepFn = () => {
            this.step = this.stepList[this.activeStep + 1].value;

            this.$nextTick(() => {
              this.scrollToSectionStep();
            });
          };

          if(isNeedAddCart) {
            this.tryToRemoverCart()
              .then(() => {
                this.tryToStoreCart()
                  .then(() => {
                    nextStepFn();
                  })
              });
          } else {
            nextStepFn();
          }
        }
      },
      async tryToRemoverCart() {
        await this.$store.dispatch('cart/removerCart')
          .then(() => {
            return true
          })
      },
      async tryToStoreCart() {
        const meals = Object.keys(this.submitData.meals)
          .filter(id => {
            return this.submitData.meals[id]
          })
          .map(id => {
            return {
              id,
              value: this.submitData.meals[id]
            }
          });

        await this.$store.dispatch('cart/storeCart', {
          ...this.submitData,
          eventAlias: this.cartItem.alias,
          eventSeriesNum: this.cartItem.seriesNum,
          meals
        })
          .then(() => {
            return true
          })
      },
      onPrev() {
        const isFirstStep = this.activeStep === 0;

        if(isFirstStep) {
          const goToBack = () => {
            this.$router.go(-1);
          };

          goToBack();
        } else {
          this.step = this.stepList[this.activeStep - 1].value;

          this.$nextTick(() => {
            this.scrollToSectionStep();
          });
        }
      },
      tryToCheckoutCart() {
        const meals = this.submitData.mealIds.map(id => {
          return {
            id,
            value: this.submitData.mealIds[id]
          }
        });

        this.$store.dispatch('cart/checkOutCart', {
          ...this.submitData,
          meals,
        })
          .then((response) => {

            const goToEventApplyDetail = () => {
              // console.log(response.items.uuid)
              if(this.$gtm) {
                if(this.$gtm.enabled()) {
                  this.$gtm.trackEvent({
                    event: 'ilinker.apply.success', // Event type [default = 'interaction'] (Optional)
                    email: response.items.email,
                    activity: response.items.eventTitle,
                    member_id: response.items.phoneNumber
                  });
                }
              }
              this.$router.replace({
                  name: 'event-apply-detail',
                  params: {
                    uuid: response.items.uuid,
                    brandAlias: this.$route.params.brandAlias,
                    eventAlias: this.$route.params.eventAlias,
                    eventSeriesNum: this.$route.params.eventSeriesNum,
                  }
                },
              )
            };

            goToEventApplyDetail();
          })
          .catch((error) => {
            if(error.status === 'CART_SESSION_HAS_BEEN_REGISTERED') {
              this.submitData.sessionRepeatUuids = _uniq([
                ...this.submitData.sessionRepeatUuids,
                ...error.data.items.sessions.map(item => {
                  return item.uuid
                })
              ]);

              this.submitData.sessionUuids = this.submitData.sessionUuids.filter(uuid => {
                return !this.submitData.sessionRepeatUuids.includes(uuid)
              });

              if(this.cartItem.registrationType === 'impartial') {
                this.$alert('無法重複報名', {
                  customClass: 'isStyleBase',
                  title: '報名錯誤',
                  confirmButtonText: '確定',
                  showClose: false
                })
                  .then(() => {
                    const goToBrandEventItem = () => {
                      this.$router.replace({
                        name: 'brand-event-item',
                      })
                    };

                    goToBrandEventItem();
                  })
              } else {
                const repeatSessionContent = error.data.items.sessions
                  .map(item => {
                    return item.title
                  })
                  .join('<br>');

                this.$alert(`下列場次無法重複報名:<br>${ repeatSessionContent }`, {
                  customClass: 'isStyleBase',
                  title: '報名錯誤',
                  confirmButtonText: '確定',
                  showClose: false,
                  dangerouslyUseHTMLString: true
                })
                  .then(() => {
                    this.step = 0;

                    this.scrollToSectionStep();
                  })
              }
            } else {
              let errMessage = error.data?.Message || error.message;
              if(error.status === 'CART_REQUIRE_ATTEND_EVENTS') {
                
                let str = "";
                const items = [...error.data?.items]
                items.forEach((item) => {
                  str+= `
                    <li>
                    ${ item.canApply 
                      ? `<a href="${ window.location.origin }${ this.$router.resolve({
                            name: 'brand-event-item',
                            params: {
                              brandAlias: item.brands[0]?.alias,
                              eventAlias: item.alias,
                              eventSeriesNum: item.seriesNum,
                            }
                        }).href}"
                        class="text-decoration-none link"
                      >
                        ${item.title}
                      </a>` 
                      : 
                      `${item.title} (已截止)`
                    }
                    </li>
                  `
                })
                errMessage = `
                  ${error.message}
                  <ul>
                    ${str}
                  </ul>
                `
              }
              this.$alert(errMessage, {
                customClass: 'isStyleBase',
                title: '報名錯誤',
                confirmButtonText: '確定',
                showClose: false,
                dangerouslyUseHTMLString: true
              })
                .then(() => {
                  const goToBrandEventItem = () => {
                    this.$router.replace({
                      name: 'brand-event-item',
                    })
                  };

                  if(error.status === 'CART_EVENT_NEED_COUPON') {
                    // this.scrollToSectionStep();
                  } else {
                    goToBrandEventItem();
                  }
                })
            }
          })
      },
      onClickStep(step) {
        if(step < this.step) {
          this.step = step;

          this.scrollToSectionStep();
        }
      },
    },
  }
</script>
<template>
  <Layout>
    <BaseBanner
      :title="`${ cartItem.title }` || '報名'"
      type="event"
      :image="require('@assets/images/course/index_banner.png')"
      custom-class="isStyleWhite isDefaultBgEventItem isArticle"
    />
    <section :class="$style.sectionCourseApply" class="section">
      <div class="container">
        <div ref="sectionStep">
          <BaseStep
            v-model="activeStep"
            :list="stepList"
            class="mb-5"
            @change="onClickStep"
          />
        </div>
        <component
          :is="`FormApplyStep${step}`"
          v-model="submitData"
          :cart-item="cartItem"
          :loading="$isLoading('removeCart') || $isLoading('storeCart')  || $isLoading('checkOutCart')"
          @submit="onSubmitStep"
          @prev="onPrev"
        />
        <BasePre>
          sessionRepeatUuids: {{ submitData.sessionRepeatUuids }}
        </BasePre>
        <BasePre>
          activeStep: {{ activeStep }}
        </BasePre>
        <BasePre>
          step: {{ step }}
        </BasePre>
        <BasePre>
          submitData: {{ submitData }}
        </BasePre>
        <BasePre>
          cartItem: {{ cartItem }}
        </BasePre>
      </div>
    </section>
  </Layout>
</template>
<style lang="scss" module>
  .sectionCourseApply {
    background-color: $color-gray-2;
    @include max-md {
      padding-bottom: 3rem;
    }
    :global {
      .sectionCourseApply {
        &__step {
          max-width: 1080px;
          margin-right: auto;
          margin-bottom: 3rem;
          margin-left: auto;
        }

        &__list {
          padding-bottom: 2rem;
        }
      }
    }
  }
</style>
